/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const MoveUpLeft = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M5 11V5H11" }],
    ["path", { d: "M5 5L19 19" }]
  ]
];

export { MoveUpLeft as default };
//# sourceMappingURL=move-up-left.js.map
